import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FamilyCodes } from 'src/app/core/_enums/family.code';
import { Energie } from 'src/app/core/_models/energie';
import { Transport } from 'src/app/core/_models/transport';

@Component({
  selector: 'app-dialog-journey',
  templateUrl: './dialog-journey.component.html',
  styleUrls: ['./dialog-journey.component.scss']
})
export class DialogJourneyComponent implements OnInit {
  FamilyCodes = FamilyCodes;

  constructor(
    public dialogRef: MatDialogRef<DialogJourneyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.selectTransportChange(this.data?.transportId || this.data?.transports?.[0]?.resourceId);
    this.selectEnergyChange(this.data?.energyId);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectTransportChange(value: string) {
    let t: Transport = this.data?.transports?.find((t: Transport) => t.resourceId == value);
    if (t) {
      this.data.familyCode = t?.familyCode;
      this.data.transportDisplayName = t?.displayName;
      this.data.transportId = t?.resourceId;
      if (t?.familyCode != FamilyCodes.RoadTransportCode) {
        this.data.energyDisplayName = null;
        this.data.energyId = null;
        this.data.energieDescription = t.energieDescription;
      } else {
        this.data.energieDescription = null;
        if (!this.data.energyId) {
          const dieselEnergy = this.data?.energies?.find((e: Energie) => e.code === FamilyCodes.DefaultDieselEnergy) ?? this.data?.energies?.find((e: Energie) => e.code === FamilyCodes.DefaultDieselEnergyIntl);
          if (dieselEnergy) {
            this.data.energyId = dieselEnergy.resourceId;
            this.data.energyDisplayName = dieselEnergy.displayName;
          }
        }
      }
    }
  }

  selectEnergyChange(value: string) {
    let e: Energie = this.data?.energies?.find((e: Energie) => e.resourceId == value);
    if (e) {
      this.data.energyDisplayName = e?.displayName;
    }
  }
}
